import { render } from "./FreeFoundationalReport.vue?vue&type=template&id=d0f32fb6&scoped=true"
import script from "./FreeFoundationalReport.vue?vue&type=script&lang=js"
export * from "./FreeFoundationalReport.vue?vue&type=script&lang=js"

import "./FreeFoundationalReport.vue?vue&type=style&index=0&id=d0f32fb6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0f32fb6"]])

export default __exports__